import { render, staticRenderFns } from "./residenceInformation.vue?vue&type=template&id=3ac7a7f8&scoped=true&"
import script from "./residenceInformation.vue?vue&type=script&lang=js&"
export * from "./residenceInformation.vue?vue&type=script&lang=js&"
import style0 from "./residenceInformation.vue?vue&type=style&index=0&id=3ac7a7f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac7a7f8",
  null
  
)

export default component.exports